import { map } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { Profile } from '../../../profile/store/profile.entity';
import { ProfileService } from '../../../profile/providers/profile.service';
import { AuthStateProvider } from '../../../auth/auth-state.provider';
import { AppState } from '../../store/header.state';
import { BrandingService } from '../../../branding/providers/branding.service';
import { BrandingState } from '../../../branding/store/branding.state';
import { AccessibilityService } from '../../../../providers/accessibility/accessibility.service';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { NgClass, AsyncPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { DASHBOARD_ROUTE } from '../../../../routes';
import { TranslationComponent } from '../../../../providers/translate/component/translation.component';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [NgClass, AsyncPipe, TranslatePipe, RouterLink, TranslationComponent]
})
export class HeaderComponent implements OnInit {
    public remoteVideoVisibility$: Observable<boolean>;
    public hideHeaderLogo$: Observable<boolean>;
    public isAuthenticated$: Observable<boolean>;
    public profileData$: Observable<Profile>;
    public brandingSettings$: Observable<BrandingState>;
    public logoUrls$: Observable<any>;
    public dashboardRoute = DASHBOARD_ROUTE;

    constructor(private profileService: ProfileService,
                private authProvider: AuthStateProvider,
                private store: Store<AppState>,
                private brandingService: BrandingService,
                private accessibilityService: AccessibilityService,
                private translate: TranslateService) {
    }

    ngOnInit(): void {
        this.profileData$ = this.profileService.getCurrentProfileDataObserver();
        this.isAuthenticated$ = this.authProvider.isAuthenticated();
        this.remoteVideoVisibility$ = this.store.select(s => s.header.remoteVideoVisible);
        this.hideHeaderLogo$ = this.store.select(s => s.header.hideHeaderLogo);
        this.brandingSettings$ = this.brandingService.getBrandingSettingsFromStore();
        this.logoUrls$ = this.brandingSettings$.pipe(
            map(settings => {
                const logo = settings.logoUrl || '/assets/img/general/patientus-by-jameda.png';
                const smallLogo = settings.smallLogoUrl || '/assets/img/general/patientus-symbol.png';
                return {logoUrl: logo, smallLogoUrl: smallLogo};
            }));
    }

    public logout() {
        // BFSG: Announce logout action to screen readers
        this.translate.get('ACCESSIBILITY.SR_LOGOUT_ATTEMPT').subscribe(message => {
            this.accessibilityService.announceToScreenReader(message, 'polite');
        });

        this.authProvider.logOut();

        // BFSG: Announce successful logout
        setTimeout(() => {
            this.translate.get('ACCESSIBILITY.SR_LOGOUT_SUCCESS').subscribe(message => {
                this.accessibilityService.announceToScreenReader(message, 'polite');
            });
        }, 500);
    }
}
